<template>
    <div>
        <div class="search-box">
            <p>竞赛名称：</p>
            <a-input class="input-box" v-model="searchFrom.competitionName" />
            <p>竞赛主办方：</p>
            <a-input class="input-box" v-model="searchFrom.sponsor" />
            <p>奖项类型：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.awardTypeCode">
                <a-select-option v-for="(item,index) in hjlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="plus" class="right-btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=add')">新增</a-button> -->
        </div>
        <div class="operation-box">
            <a-button type="primary" v-if="permissions.indexOf('undergraduate:student:subject:add')>-1" icon="plus" class="btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=add')">新增</a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0]==null?selectedCheck():remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:student:subject:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0]==null?selectedCheck():$router.push('/admin/undergraduate/student/subject/info?type=update&id='+selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:student:subject:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" v-if="permissions.indexOf('undergraduate:student:subject:query')>-1" @click="selectedRowKeys[0]==null?selectedCheck():$router.push('/admin/undergraduate/student/subject/info?type=look&id='+selectedRowKeys[0])" >查看详情</a-button>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <template slot="organizedDepartmentCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.organizedDepartmentCode" disabled>
                    <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="guideTeacherNo" slot-scope="text,record">{{record.guideTeacherName}}/{{text}}</template>
            <template slot="participateDepartmentCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.participateDepartmentCode" disabled>
                    <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="awardLevelCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.awardLevelCode" disabled>
                    <a-select-option v-for="(item,index) in hjdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="awardTypeCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.awardTypeCode" disabled>
                    <a-select-option v-for="(item,index) in hjlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <!-- <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$router.push('/admin/undergraduate/student/subject/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/undergraduate/student/subject'
    import { selectedCheck } from '@/baseAPI/util'

    const columns = [
        {
            title: '序号',
            dataIndex: 'lastUpdateTime',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '组织学院',
            dataIndex: 'organizedDepartmentCode',
            align:'center',
            scopedSlots: { customRender: 'organizedDepartmentCode' }
        },
        {
            title: '参赛学院',
            dataIndex: 'participateDepartmentCode',
            align:'center',
            scopedSlots: { customRender: 'participateDepartmentCode' }
        },
        {
            title: '竞赛全称',
            dataIndex: 'competitionName',
            align:'center'
        },
        {
            title: '竞赛主办方',
            dataIndex: 'sponsor',
            align:'center'
        },
        {
            title: '举办日期',
            dataIndex: 'holdDate',
            align:'center'
        },
        {
            title: '竞赛项目/组别',
            dataIndex: 'competeEventGroup',
            align:'center'
        },
        {
            title: '指导教师/工号',
            dataIndex: 'guideTeacherNo',
            align:'center',
            scopedSlots: { customRender: 'guideTeacherNo' }
        },
        {
            title: '奖项名称',
            dataIndex: 'awardName',
            align:'center'
        },
        {
            title: '获奖等级',
            dataIndex: 'awardLevelCode',
            align:'center',
            // scopedSlots: { customRender: 'awardLevelCode' }
        },
        {
            title: '奖项类型',
            dataIndex: 'awardTypeCode',
            align:'center',
            scopedSlots: { customRender: 'awardTypeCode' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                selectedRowKeys: [],
                permissions:[],
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    departmentCode:'',
                    teacherName:'',
                    courseName:'',
                },
                xyArr:[],
                hjdjArr:[],
                hjlxArr:[],

            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xyArr=res.data.dicts;
            })
            getDicts({dataCode:'XKJS_HJDJ',status:true}).then(res=>{
                this.hjdjArr=res.data.dicts;
            })
            getDicts({dataCode:'XKJS_HJLX',status:true}).then(res=>{
                this.hjlxArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            selectedCheck(){
                selectedCheck()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除学科竞赛成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
